export default __webpack_public_path__ + "4d09a0c.png";